import { InsertCuentaBancariaContactoCommandProps } from "api/Commands/CuentaBancariaInsertCuentaBancariaContactoCommand"
import { UpdateCuentaBancariaContactoCommandProps } from "api/Commands/UpdateCuentaBancariaContactoCommand"
import { backendDateFormat } from "utils/formatDate"
import { CuentaBancariaFormValues } from "./UseCuentaBancariasForm"

export const adapterPostCuentaBancariaContacto = (
  data: CuentaBancariaFormValues
): InsertCuentaBancariaContactoCommandProps => ({
  bic: data.bic,
  entidadBancariaId: data.entidadBancariaId,
  iban: data.iban,
  mandato: {
    fecha: data.mandato.fecha ? backendDateFormat(data.mandato.fecha) : null,
    referencia: data.mandato.referencia ?? null,
    tipoRemesa: data.mandato.tipoRemesa ?? null,
  },
  principal: data.principal,
})

export const adapterPutCuentaBancariaContacto = (
  data: CuentaBancariaFormValues
): UpdateCuentaBancariaContactoCommandProps => ({
  id: data.id,
  cuentaBancaria: {
    id: data.id,
    bic: data.bic,
    entidadBancariaId: data.entidadBancariaId,
    iban: data.iban,
    mandato: {
      fecha: data.mandato.fecha ? backendDateFormat(data.mandato.fecha) : null,
      referencia: data.mandato.referencia ?? null,
      tipoRemesa: data.mandato.tipoRemesa ?? null,
    },
    principal: data.principal,
  },
})
